import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=856f5c0e&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user_center.css?vue&type=style&index=0&id=856f5c0e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856f5c0e",
  null
  
)

export default component.exports